<div class="p-form-layout04">
  <!--　サービス更新情報　セグメント分繰り返し　-->
  <div *ngFor="let seg of service.updateInfo.segment; index as k" class="p-form-layout04__item">
    <div class="p-form-layout04__item-title p-form-layout04__item-title--l">
      <div class="p-form-layout04__item-title-label p-form-layout04__item-title-label--em">
        <div class="p-form-layout04__item-airport">
          <span class="p-form-layout04__item-airport-departure">{{ seg.locationName }}</span>
        </div>
      </div>
    </div>
    <div class="p-input-block02">
      <!--　サービス更新情報　セグメント.搭乗者分繰り返し　-->
      <div *ngFor="let passenger of seg.passengerInformation; index as j" class="p-input-block02__item">
        <!--　サービス更新情報　セグメント.搭乗者.搭乗者名分繰り返し　2次元配列-->
        <ng-container *ngFor="let traveler of passenger.travelers">
          <div
            *ngFor="let item of traveler; index as i"
            class="p-input-block02__item-title p-input-block02__item-title--m p-input-block02__item-title--has-text"
          >
            <div
              class="p-input-block02__item-title-label"
              [ngClass]="{ 'p-input-block02__item-title-label--em': i === 0 }"
            >
              {{ item.name }}
            </div>
            <div class="p-input-block02__item-title-lead" [innerHTML]="item.type | staticMsg"></div>
          </div>
        </ng-container>
        <div class="p-input-block02__row">
          <div class="p-input-block02__row-body">
            <div class="p-input-block02__row-body-item">
              <!--　サービス更新情報　セグメント.搭乗者.SSR分繰り返し-->
              <div
                *ngFor="let item of passenger.ssr.selectedList; index as i"
                class="c-form-element-checkbox-button01"
                [ngClass]="{ ' is-selected': item.isSelected }"
              >
                <!--　チェックボックスを表示するか判定-->
                <div *ngIf="!item.status || item.isSelected" class="c-form-element-checkbox-button01__wrap">
                  <input
                    type="checkbox"
                    name="lounge-application-modal-catalog{{ k }}_{{ j }}_{{ i }}"
                    id="lounge-application-modal-catalog{{ k }}_{{ j }}_{{ i }}_1"
                    class="c-form-element-checkbox-button01__input"
                    [(ngModel)]="item.isSelected"
                    (change)="clickSsrCode(item.isSelected, item.catalogCode, passenger)"
                    [checked]="item.isSelected"
                  />
                  <label
                    for="lounge-application-modal-catalog{{ k }}_{{ j }}_{{ i }}_1"
                    class="c-form-element-checkbox-button01__label"
                  >
                    <span
                      class="c-form-element-checkbox-button01__text c-form-element-checkbox-button01__text--has-status"
                    >
                      <span class="c-form-element-checkbox-button01__text-label"
                        >{{ item.dispName }}:{{ item.status }}</span
                      >
                      <span class="c-form-element-checkbox-button01__text-status">
                        <!--　金額を表示するか判定-->
                        <span
                          *ngIf="item.isTotalDisp"
                          class="c-amount c-amount--price"
                          [innerHTML]="item.total | amountFormat : 'default' : item.currencyCode"
                        >
                          <!--
                          <span class="c-amount__unit c-amount__unit--fs20">¥</span>
                          <span class="c-amount__num c-amount__num--fs20">{{ item.total }}</span>
                        -->
                        </span>
                      </span>
                    </span>
                    <span class="c-form-element-checkbox-button01__check"></span>
                  </label>
                </div>
                <!--　ステータス（売り切れ等）を表示するか判定-->
                <div *ngIf="item.status" class="c-status-display">
                  <span class="c-status-display__body c-status-display__body--has-status">
                    <span class="c-status-display__text">
                      <span class="c-status-display__text-label">{{ item.dispName }}</span>
                    </span>
                    <span class="c-status-display__status">{{ item.status }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="serviceRecommendationArea"></div>
</div>
